import { useState } from "react";
import { FeedbackForm } from "./components/FeedbackForm";
import { ConfirmationPage } from "./components/ConfirmationPage";
import { PopUpMessage } from "../../shared/components/PopUpMessage";
import axios from "axios";

const SERVER = process.env.REACT_APP_SERVER;

export const PdoFeedback = () => {
    const [page, setPage] = useState<"feedback" | "confirmation">("feedback");
    const [popUpMessage, setPopUpMessage] = useState("");
    const [popUpOpen, setPopUpOpen] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        role: "", // Student / Parent / Other
        satisfaction: "",
        usefulness: "",
        speakerRating: "",
        likedMost: "",
        improvement: "",
    });

    const handleFieldChange = (field: string, value: string) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleFailure = () => {
        setPopUpMessage("Service unavailable, please try again in a minute.");
        setPopUpOpen(true);
    };

    const handleSubmit = () => {
        if (!formData.name || !formData.email || !formData.role || !formData.satisfaction || !formData.usefulness || !formData.speakerRating) {
            setPopUpMessage("Please fill out all required fields.");
            setPopUpOpen(true);
            return;
        }

        setSubmitted(true);

        axios.post(`${SERVER}/pdo/feedback`, formData).then((res) => {
            if (res.status === 200) {
                setPage("confirmation");
                return;
            }
            handleFailure();
            setSubmitted(false);
        }).catch(() => {
            handleFailure();
            setSubmitted(false);
        });
    };

    return (
        <div>
            <PopUpMessage
                open={popUpOpen}
                handleClose={() => setPopUpOpen(false)}
                message={popUpMessage}
            />
            <div className="flex flex-col lg:flex-row min-h-screen pt-navbar py-40 mx-[10%]">
                <div className={`lg:order-2 flex-auto w-full`}>
                    <div className={`w-[100%] ${page === 'confirmation' ? "p-[12%]" : "px-[12%]"}`}>
                        <h2>
                            {page === "confirmation"
                                ? "Thanks for your feedback!"
                                : "PDO Feedback Form"}
                        </h2>
                        {page === "feedback" &&
                            <div className="xl:max-w-[65%] py-6 flex flex-col gap-3">
                                <p>
                                    Thank you for attending PDO! We hope you had a great experience. <br />Your feedback is valuable and helps us improve future events.
                                </p>
                            </div>
                        }
                        {page === "feedback" && (
                            <>
                                <FeedbackForm state={formData} handleFieldChange={handleFieldChange} />

                                <button
                                    className="block bg-[#D07D14] w-full rounded-md text-white py-1.5 text-lg mt-7 disabled:bg-gray-400"
                                    onClick={handleSubmit}
                                    disabled={submitted}
                                >
                                    Submit Feedback
                                </button>
                            </>
                        )}
                        {page === "confirmation" && <ConfirmationPage />}
                    </div>
                </div>
            </div>
        </div>
    );
};
